export const es_dashboard = {
    mappatura: 'cartografia',
    scan_di_mercato: 'scan di mercato',
    mapped_build: 'Immobili Mappati',
    new_auction: 'Aste Inserite',
    operations: 'Operazioni in corso',
    closed_operations: 'Operazioni concluse',
    cash_flow: 'Capitale Iniziale',
    last_30_days_subtitle: 'negli ultimi 30 giorni',
    operations_charts_1: 'Andamento attività',
    operations_charts_2: 'Mappature/Mq',
    cashflow: 'Il tuo capitale iniziale',
    cashflow_label: 'Ti servirà come promemoria per le tue operazioni',

    popover_archive_title: 'Le tue attività',
    popover_archive_content: '<p>In questa card è possibile valutare l’andamento delle operazioni inserite e valutare il livello di attività del lavoro in base al tempo.</p>',
    descrizione_mappatura: '<p>Puede mapear inmediatamente sus propiedades a través de la plataforma <strong> pisos.com </strong> e <strong> fotocasa.es </strong>  <br> e identificar rápidamente las operaciones a ser investigado.</p>',
    citta: 'Ciudad*',
    zona: 'Zona*',
    macro_zona: 'Zona macro',
    micro_zona: 'Zona micro',
    salva_disegna: 'guardar y dibujar la zona',
    acquista_pacchetto: 'comprar el paquete',
    rimuovi_autorizzazione: 'eliminar autorización',
    aggiungi_evento: 'agregar el evento',
    attiva_calendar: 'activa tu calendario de google',
    in_analisi: 'en análisis',
    in_corso: 'en curso',
    chiuse: 'cerrado',
    nessuno: 'nadie',
    annuncio_portale: 'anuncio en el sitio web',
    conto_economico: 'Estado de Cuenta',

    sb_mappatura_scan: 'Mapeo',
    sb_archivio_mappatura: 'Archivo de mapeo',
    sb_mie_operazioni: 'Mis operaciones',
    sb_mio_team: 'Mi Equipo',
    sb_mio_task: 'Mi Task',
    sb_pillole_immobiliari: 'Asesoramiento inmobil.',
    sb_proponi_idea: 'Proponer una idea',
    sb_novita: 'Anuncios',
    check_link_enable: 'Activar',
    check_link_disable: 'Desactivar',
    torna_al_sito_ufficiale: 'Volver al sitio oficial',
    torna_area_coach: 'Vuelve al área de autocares',
    check_link_modal_title: 'control automático',
    check_link_modal_subtitle: 'versión BETA',
    check_link_modal_description: 'Administre automáticamente la cancelación de propiedades vencidas en su lista importada.',
    check_link_modal_alert: 'Esta opción es válida solo para los portales <strong> immobiliare.it </strong> y <strong> casa.it </strong>. <br>El servicio, una vez activado, entrará en vigor en el archivo después de aproximadamente 48 horas<br>' +
        'Si un estado de resultados está vinculado al anuncio <strong>, no se eliminará (ni el anuncio ni el estado de resultados).',

    check_link_modal_cancel: 'Cerrar',
    sb_trash:'Basura'
};
